@if (visible) {
  <div class="flex flex-col gap-3 rounded-2xl bg-vw-surface-tint p-4">
    <p class="text-body-s text-vw-ink">{{ 'season-plan.banner.text' | translate: { year: today.getFullYear() } }}</p>
    <vw-button label="season-plan.banner.action" [look]="'primary'" [size]="'small'" customClass="self-start"
      (onClick)="open()"></vw-button>
  </div>
}
